<template lang="pug">
    re-toast-alert(v-bind="parentOptions")
        template(v-slot:default="{alert}")
            include ./confirm-content-checkbox.pug
</template>

<script>
import ConfirmMixin from '../mixins/confirm'
import ReToastAlert from 'utils/vue/components/elements/re-toast-alert'
import ReCheckbox from 'utils/vue/components/basic/form/re-checkbox'

export default {
    name: 'cart-rules-confirm-bar-checkbox',

    components: {
        ReToastAlert,
        ReCheckbox,
    },

    mixins: [
        ConfirmMixin
    ],

    data: () => ({
        defaultParentOptions: {
            type: 'info',
            toast: false
        }
    })
}
</script>
